import { getPurchaseOrderPdf } from '../../api';

const toBlobUrl = (data) =>
  window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));

// Fetch the PO PDF and open the browser print dialog for it. Uses a hidden
// iframe so the print menu opens directly instead of just viewing the file.
export const printPurchaseOrder = async (id) => {
  const { data } = await getPurchaseOrderPdf(id);
  const url = toBlobUrl(data);

  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = url;
  iframe.onload = () => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
  };
  document.body.appendChild(iframe);

  // Keep the iframe alive long enough for the print dialog, then clean up.
  setTimeout(() => {
    iframe.remove();
    window.URL.revokeObjectURL(url);
  }, 60000);
};

// Fetch the PO PDF and trigger a file download named after the PO.
export const downloadPurchaseOrder = async (id, filename) => {
  const { data } = await getPurchaseOrderPdf(id);
  const url = toBlobUrl(data);

  // The PO number can be a user-supplied doc no, so keep the filename safe.
  const safeName = (filename || `purchase-order-${id}`).replace(
    /[^A-Za-z0-9._-]+/g,
    '_'
  );

  const link = document.createElement('a');
  link.href = url;
  link.download = `${safeName}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();

  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
};
